import http from 'utils/http';

export const deleteModifier = (modifierId) => http.delete(`v1/modifiers/${modifierId}/`).then((res) => res.data);

export const changeModifierAvailability = ({ modifierId, modifier }) => http.put(`v1/modifiers/${modifierId}/`, modifier).then((res) => res.data);
